import { useTranslation } from "react-i18next";

export function Method() {
  const { t } = useTranslation();

  return (
    <section id="method" className="py-20 px-4">
      <div className="container mx-auto">
        <h2
          className="section-heading mb-4"
          style={{ opacity: 1, transform: "none" }}
        >
          {t("landingPage.method.title")}
        </h2>
        <p
          className="section-subheading mb-16"
          style={{ opacity: 1, transform: "none" }}
        >
          {t("landingPage.method.subtitle")}
        </p>
        <div className="relative max-w-6xl mx-auto">
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="relative" style={{ opacity: 1, transform: "none" }}>
              <div className="card-glass p-6 h-full flex flex-col">
                <div className="aspect-video rounded-lg overflow-hidden mb-6 bg-card">
                  <img
                    src="/initial-assessment.png"
                    alt="Initial Assessment"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div
                  className="step-number mb-2"
                  style={{ opacity: 1, transform: "none" }}
                >
                  01
                </div>
                <h3 className="text-xl font-bold text-foreground mb-3">
                  {t("landingPage.method.steps.0.title")}
                </h3>
                <p className="text-muted-foreground text-sm mb-6 flex-1">
                  {t("landingPage.method.steps.0.description")}
                </p>
                <a
                  href="/book-a-call"
                  className="btn-secondary w-full justify-center"
                >
                  <span>{t("landingPage.method.getStarted")}</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-arrow-right w-4 h-4"
                  >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </a>
              </div>
              {/* <div className="hidden lg:block absolute -bottom-3 left-1/2 -translate-x-1/2 w-3 h-3 rounded-full bg-primary shadow-lg shadow-primary/50" /> */}
            </div>
            <div className="relative" style={{ opacity: 1, transform: "none" }}>
              <div className="card-glass p-6 h-full flex flex-col">
                <div className="aspect-video rounded-lg overflow-hidden mb-6 bg-card">
                  <img
                    src="/nutrition-strategy.png"
                    alt="Nutrition Strategy"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div
                  className="step-number mb-2"
                  style={{ opacity: 1, transform: "none" }}
                >
                  02
                </div>
                <h3 className="text-xl font-bold text-foreground mb-3">
                  {t("landingPage.method.steps.1.title")}
                </h3>
                <p className="text-muted-foreground text-sm mb-6 flex-1">
                  {t("landingPage.method.steps.1.description")}
                </p>
                <a
                  href="/book-a-call"
                  className="btn-secondary w-full justify-center"
                >
                  <span>{t("landingPage.method.getStarted")}</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-arrow-right w-4 h-4"
                  >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </a>
              </div>
              {/* <div className="hidden lg:block absolute -bottom-3 left-1/2 -translate-x-1/2 w-3 h-3 rounded-full bg-primary shadow-lg shadow-primary/50" /> */}
            </div>
            <div className="relative" style={{ opacity: 1, transform: "none" }}>
              <div className="card-glass p-6 h-full flex flex-col">
                <div className="aspect-video rounded-lg overflow-hidden mb-6 bg-card">
                  <img
                    src="/smart-training.png"
                    alt="Smart Training"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div
                  className="step-number mb-2"
                  style={{ opacity: 1, transform: "none" }}
                >
                  03
                </div>
                <h3 className="text-xl font-bold text-foreground mb-3">
                  {t("landingPage.method.steps.2.title")}
                </h3>
                <p className="text-muted-foreground text-sm mb-6 flex-1">
                  {t("landingPage.method.steps.2.description")}
                </p>
                <a
                  href="/book-a-call"
                  className="btn-secondary w-full justify-center"
                >
                  <span>{t("landingPage.method.getStarted")}</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-arrow-right w-4 h-4"
                  >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </a>
              </div>
              {/* <div className="hidden lg:block absolute -bottom-3 left-1/2 -translate-x-1/2 w-3 h-3 rounded-full bg-primary shadow-lg shadow-primary/50" /> */}
            </div>
            <div className="relative" style={{ opacity: 1, transform: "none" }}>
              <div className="card-glass p-6 h-full flex flex-col">
                <div className="aspect-video rounded-lg overflow-hidden mb-6 bg-card">
                  <img
                    src="/mindset-accountability.png"
                    alt="Mindset & Accountability"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div
                  className="step-number mb-2"
                  style={{ opacity: 1, transform: "none" }}
                >
                  04
                </div>
                <h3 className="text-xl font-bold text-foreground mb-3">
                  {t("landingPage.method.steps.3.title")}
                </h3>
                <p className="text-muted-foreground text-sm mb-6 flex-1">
                  {t("landingPage.method.steps.3.description")}
                </p>
                <a
                  href="/book-a-call"
                  className="btn-secondary w-full justify-center"
                >
                  <span>{t("landingPage.method.getStarted")}</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-arrow-right w-4 h-4"
                  >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </a>
              </div>
              {/* <div className="hidden lg:block absolute -bottom-3 left-1/2 -translate-x-1/2 w-3 h-3 rounded-full bg-primary shadow-lg shadow-primary/50" /> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
